import React from 'react';
import { components } from 'react-select';
import { kebabCase } from 'lodash';
import PropTypes from 'prop-types';
import { Icon, Layout, Typography } from '../../../core';

const { Option } = components;

const CheckboxIcon = ({ isChecked }) => (
  <Layout variant="flex" align="center" justify="center" boxSize="1lh" flexShrink={0} pointerEvents="none" minW={0}>
    <Icon
      iconName={isChecked ? 'square-check' : 'square'}
      prefix={isChecked ? 'fas' : 'far'}
      color={isChecked ? 'var(--udl-colors-text-brand)' : 'var(--udl-colors-icon-default)'}
      size="lg"
    />
  </Layout>
);

export const SelectCheckboxOption = props => {
  const { isMulti, isSelected, label, multi, selectProps, helperText, children } = props;
  const formattedName = selectProps?.name?.replace?.('[]', '') ?? '';
  const name = formattedName ? `-${formattedName}` : '';
  const optionIndex = selectProps?.options?.map?.(option => option?.label)?.indexOf?.(label);
  const dataAction = `select-option-${kebabCase(label)}`;
  const dataObjectId = `Select${name}-option-${optionIndex}`;
  const multiSelect = isMulti || multi;

  return (
    <Option
      {...props}
      innerProps={{
        ...props.innerProps,
        'data-action': dataAction,
        'data-object-id': dataObjectId,
      }}
    >
      <Layout variant="stack" flexDirection="row" gap="xs" textStyle="p2" alignItems="flex-start">
        {multiSelect && <CheckboxIcon isChecked={isSelected} />}
        <Layout variant="stack" justifyContent="flex-start" as="span" w="full">
          <Typography as="span">{children || label}</Typography>
          {helperText && (
            <Typography textStyle={'p3'} mb={0} color="var(--udl-colors-text-muted)" as="span">
              {helperText}
            </Typography>
          )}
        </Layout>
        {!multiSelect && isSelected && <Icon iconName="check" prefix="fas" />}
      </Layout>
    </Option>
  );
};

SelectCheckboxOption.propTypes = {
  helperText: PropTypes.string,
  isMulti: PropTypes.bool,
  isSelected: PropTypes.bool,
  label: PropTypes.string,
  multi: PropTypes.bool,
  useRightCheckmark: PropTypes.bool,
  selectProps: PropTypes.shape({
    name: PropTypes.string,
    options: PropTypes.array,
  }),
};
